import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'

import image from '../../../assets/images/payroll-cards/benefits.webp'
import figure from '../../../assets/images/shapes/yellow-bottom-right.svg'
import Footnote from '../../../components/footnote/Footnote'
import Paths from '../../../utils/paths'
import useStyles from '../PayrollCards.styles'

export default function PayrollCardsBenefits () {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <div className='slide-carousel row ps-4 ps-md-5' style={{ background: '#1E4164' }}>
      <div className='col-12 col-md-6 d-flex flex-column px-0 px-md-5 justify-content-center' style={{ color: 'white', textAlign: 'left' }}>
        <h2 className='pb-4'>Make Payday Easy—for Everyone</h2>
        <p>Whether you're looking to modernize your payroll, support unbanked staff, or reduce payroll headaches, our Payroll Card Program delivers.</p>
        <h4><b>ONE CARD - MANY BENEFITS</b></h4>
        <ul style={{ marginTop: 16, marginBottom: 16 }}>
          <li>Direct deposit ready</li>
          <li>Earned wage access⁴</li>
          <li>ATM withdrawals</li>
          <li>Cashback and discounts</li>
          <li>Mobile app for balance and transactions</li>
          <li>Physical and digital card options</li>
        </ul>
        <Footnote color='white' omitPadding notes={['⁴ Subject to Terms & Conditions. Central Bank of Kansas City does not administer nor is liable for Pay on-demand /earned wage access or tips access.']} />
      </div>
      <div className='col-6 d-none d-md-flex justify-content-end align-items-end pe-5'>
        <img className='carrousel-img' alt='carouselImg' src={image} />
        <img src={figure} alt='figure' className='carousel-figure' />
      </div>
    </div>
  )
}
